import logo from "../../../../public/projects/mantri/images/logo/logo.png";
import energia from "../../../../public/projects/mantri/images/projects/energia.jpg";
import lalbagh from "../../../../public/projects/mantri/images/projects/lalbagh.jpg";

//blossom
import overviewImage_blossom from "../../../../public/projects/mantri/images/blossom/Overview/1.webp";
import bannerDesktopImage_blossom from "../../../../public/projects/mantri/images/blossom/Banner/1.webp";
import bannerMobileImage_blossom from "../../../../public/projects/mantri/images/blossom/Banner/2.webp";
import siteVisitBannerImage_blossom from "../../../../public/projects/mantri/images/blossom/SiteVisitBanner/1.webp";
import Location_blossom from "../../../../public/projects/mantri/images/blossom/Location/L1.webp";
import Hightlights_blossom from "../../../../public/projects/mantri/images/blossom/Highlights/1.webp";
import image1BHK_blossom from "../../../../public/projects/mantri/images/blossom/floorplan/1.webp";
import image2BHK_blossom from "../../../../public/projects/mantri/images/blossom/floorplan/2.webp";
import image3BHK_blossom from "../../../../public/projects/mantri/images/blossom/floorplan/3.webp";
import location_blossom from "../../../../public/projects/mantri/images/blossom/Overview/l.png";
import cal_blossom from "../../../../public/projects/mantri/images/blossom/Overview/c.png";
import newlaunch_blossom from "../../../../public/projects/mantri/images/blossom/Overview/n.png";
import g1_blossom from "../../../../public/projects/mantri/images/blossom/Gallery/1.webp";
import g2_blossom from "../../../../public/projects/mantri/images/blossom/Gallery/2.webp";
import g3_blossom from "../../../../public/projects/mantri/images/blossom/Gallery/3.webp";
import g4_blossom from "../../../../public/projects/mantri/images/blossom/Gallery/4.webp";
import g5_blossom from "../../../../public/projects/mantri/images/blossom/Gallery/5.webp";

//energia
import overviewImage_energia from "../../../../public/projects/mantri/images/energia/Overview/1.webp";
import bannerDesktopImage_energia from "../../../../public/projects/mantri/images/energia/Banner/1.webp";
import bannerMobileImage_energia from "../../../../public/projects/mantri/images/energia/Banner/2.webp";
import siteVisitBannerImage_energia from "../../../../public/projects/mantri/images/energia/SiteVisitBanner/1.webp";
import Location_energia from "../../../../public/projects/mantri/images/energia/Location/L1.webp";
import Hightlights_energia from "../../../../public/projects/mantri/images/energia/Highlights/1.webp";
import image1BHK_energia from "../../../../public/projects/mantri/images/energia/floorplan/1.webp";
import image2BHK_energia from "../../../../public/projects/mantri/images/energia/floorplan/2.webp";
import location_energia from "../../../../public/projects/mantri/images/energia/Overview/l.png";
import cal_energia from "../../../../public/projects/mantri/images/energia/Overview/c.png";
import newlaunch_energia from "../../../../public/projects/mantri/images/energia/Overview/n.png";
import g1_energia from "../../../../public/projects/mantri/images/energia/Gallery/1.webp";
import g2_energia from "../../../../public/projects/mantri/images/energia/Gallery/2.webp";
import g3_energia from "../../../../public/projects/mantri/images/energia/Gallery/3.webp";
import g4_energia from "../../../../public/projects/mantri/images/energia/Gallery/4.webp";
import g5_energia from "../../../../public/projects/mantri/images/energia/Gallery/5.webp";

export const developersMantri = {
  name: `Mantri Properties in Bengaluru `,
  properties: [
    {
      name: "Mantri - Energia",
      image: energia,
      price: "On Request",
      location: "Hebbal, Bengaluru",
      projectlocation: "North Bengaluru",
      state: "Bengaluru",
      developer: "Mantri ",
      bed: "2 - 3 BHK Apartments",
      size: "On Request",
      url: `/mantri-energia-hebbal-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Mantri - Blossom",
      image: lalbagh,
      price: "On Request",
      location: "Doddamavalli, Bengaluru",
      projectlocation: "Central Bengaluru",
      state: "Bengaluru",
      developer: "Mantri ",
      bed: "3 - 4 - 5 Apartments",
      size: "On Request",
      url: `/mantri-blossom-doddamavalli-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    // {
    //   name: "Mantri - Courtyard",
    //   image: "",
    //   price: "On Request",
    //   location: "Bengaluru",
    //   projectlocation: "Wellesley Road",
    //   state: "Bengaluru",
    //   developer: "Mantri ",
    //   bed: "1 - 3 BR Apartments",
    //   size: "On Request",
    //   url: `/developers/birla/birla-estate`,
    //   form: {
    //     source_id: 11,
    //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    //     sub_source_id: 130,
    //     builder_id: `103`,
    //     project_id: `477`,
    //     subject: "M3M Altitude", // Add or update the subject here
    //     to_email: "jatin.rohilla@propertystation.in",
    //   },
    // },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: "1999",
  },
  about: `In the incredibly competitive and dynamic field of real estate development, one name has continuously led the way and established the standards for others to follow. The forward-thinking, innovation-driven Mantri Developers Pvt. Ltd.With projects spanning the residential, retail, commercial, educational, and hospitality sectors, the company, founded in 1999 by Mr. Sushil Mantri, has been the driving force behind south India's quickly shifting cityscape.`,
};

export const projectsmantri = {
  blossom: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_blossom,
      bannerMobileImage: bannerMobileImage_blossom,
      textOverlay: "",
      data: {
        title: "Mantri Blossom",
        subtitle: "Doddamavalli, Mission Road, Bengaluru",
        starting_price: "On Request",
        rerano: "PR/171017/000505",
        payment_plan: "",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Mantri Blossom",
      description: [
        `Mantri Blossom is the latest luxury apartment project launched on Lalbagh Road in Basavanagudi, Bengaluru.

This residential community, Mantri Blossom, showcases the finest in Mantri Developers' luxury living offerings. The project features spacious apartments equipped with lavish amenities.

The beautiful surroundings at Mantri Blossom enhance its charm and exclusivity.

The developer promises to deliver a high-quality living experience for the residents of Lalbagh Road, Basavanagudi, Central Bengaluru, with exceptional architecture and a lifestyle to match in Mantri Blossom.

The location of Mantri Blossom offers excellent connectivity and is situated at the intersection of Lalbagh Road, Basavanagudi, near both established and upcoming communities and amenities.

Mantri Blossom provides a range of amenities, including a fully equipped clubhouse, landscaped gardens, a gymnasium, a swimming pool, recreation rooms, outdoor sports courts, a children's play area, a party hall, and is designed with great attention to state-of-the-art, round-the-clock security.


`,
      ],
      image: overviewImage_blossom,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_blossom,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_blossom,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_blossom,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_blossom,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "2485 sq. ft. - 2680 sq. ft.",
          price: "On Request",
        },
        {
          type: "3.5 BHK",
          area: "3120 sq. ft.",
          price: "On Request",
        },
        {
          type: "4 BHK",
          area: "3675  sq. ft. - 3850 sq. ft.",
          price: "On Request",
        },
        {
          type: "5 BHK",
          area: "3070 sq. ft. - 5065 sq. ft.",
          price: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "2485 sq. ft. - 2680 sq. ft.",
        price: "On Request",
        image: image1BHK_blossom,
      },
      {
        type: "3.5 BHK",
        area: "3120 sq. ft.",
        price: "On Request",
        image: image1BHK_blossom,
      },
      {
        type: "4 BHK",
        area: "3675  sq. ft. - 3850 sq. ft.",
        price: "On Request",
        image: image2BHK_blossom,
      },
      {
        type: "5 BHK",
        area: "3070 sq. ft. - 5065 sq. ft.",
        price: "On Request",
        image: image3BHK_blossom,
      },
    ],

    highlights: {
      images: Hightlights_blossom,
      tagline: "Highlights",
      features: [
        "The project offers a stunning ambiance, overseeing 240 acres of the lush greenery of Lalbagh in Bengaluru.",
        "Central Bengaluru is a well-established area that is highly desirable, with the project situated in a strategically advantageous location suitable for both investment and personal use.",
        "The reputation of Mantri Developers enhances the appeal, paired with competitive pricing and the project's prime location. ",
        "It is conveniently located near Lalbagh, Jayanagar, Basavanagudi, RV Road, and surrounded by existing communities that feature healthcare facilities, schools, and essential amenities close by.",
        "There can be certain traffic congestion during peak hours when accessing major areas in Central and South Bengaluru.",
      ],
    },

    location: {
      image: Location_blossom,
      data: [
        {
          airport: {
            distance_time: "36 km",
            name: "Kempegowda Airport",
          },
          school: {
            distance_time: "4.9 Km",
            name: "Christ University",
          },
          railwayormetro: {
            distance_time: "4.4 Km",
            name: "KSR Junction",
          },
          hospital: {
            distance_time: "1.1 Km",
            name: " South City Hospital",
          },
          mall: {
            distance_time: "4 Km",
            name: "UB City",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_blossom },
        { image: g2_blossom },
        { image: g3_blossom },
        { image: g4_blossom },
        { image: g5_blossom },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Mantri Blubelle, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Mantri - Energia",
          image: energia,
          price: "On Request",
          location: "Hebbal, Bengaluru",
          projectlocation: "North Bengaluru",
          state: "Bengaluru",
          developer: "Mantri ",
          bed: "2 - 3 BHK Apartments",
          size: "On Request",
          url: `/mantri-energia-hebbal-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },

        // {
        //   name: "Mantri - Courtyard",
        //   image: "",
        //   price: "On Request",
        //   location: "Bengaluru",
        //   projectlocation: "Wellesley Road",
        //   state: "Bengaluru",
        //   developer: "Mantri ",
        //   bed: "1 - 3 BR Apartments",
        //   size: "On Request",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  energia: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_energia,
      bannerMobileImage: bannerMobileImage_energia,
      textOverlay: "",
      data: {
        title: "Mantri Energia",
        subtitle: "Hebbal, Bengaluru",
        starting_price: "On Request",
        rerano: "PR/171014/000439",
        payment_plan: "",
        status: "Ready to Move",
      },
    },
    overview: {
      heading: "Mantri Energia",
      description: [
        `Mantri Energia is a newly launched residential apartment project situated in Hebbal, behind Manyata Tech Park, Bengaluru. 

This residential community, Mantri Energia, showcases the finest in the luxury living segment by Mantri Developers. The project provides spacious apartments outfitted with high-end features. 

Exquisite landscapes surrounding Mantri Energia enhance its appeal and exclusivity. 

The builder is committed to delivering a high-quality living experience to the residents of Hebbal, behind Manyata Tech Park, North Bengaluru, through impressive architecture and an enhanced lifestyle in Mantri Energia. 

The location of Mantri Energia boasts excellent connectivity and is positioned at the heart of Hebbal, behind Manyata Tech Park, close to both established and upcoming communities and amenities. 

Amenities at Mantri Energia are inclusive of a fully-equipped clubhouse, landscaped gardens, a gym, a swimming pool, recreational rooms, outdoor sports courts, a children's play area, a party hall, and are designed with a strong emphasis on top-notch 24/7 security.`,
      ],
      image: overviewImage_energia,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_energia,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_energia,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_energia,
          title: "Ready to Move",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_energia,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1355 sq.ft",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "1355 sq.ft",
        price: "On Request",
        image: image2BHK_energia,
      },
    ],

    highlights: {
      images: Hightlights_energia,
      tagline: "Highlights",
      features: [
        "Tropical Forest Style Landscaping",
        "Vertical Garden with Lush Greenery",
        "Illuminated Chessboard Floor",
        "Cutting-edge 30000 Sft. Community Center ",
        "Life Tree – An Organic Energy Provider",
      ],
    },

    location: {
      image: Location_energia,
      data: [
        {
          airport: {
            distance_time: "18.5 Km",
            name: "Kempegowda Airport",
          },
          school: {
            distance_time: "290 m",
            name: "Government High School",
          },
          railwayormetro: {
            distance_time: "16.9 km",
            name: "Majestic Station",
          },
          hospital: {
            distance_time: "5 Km",
            name: "Baptist Hospital",
          },
          mall: {
            distance_time: "2.4 Km",
            name: "Elements Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_energia },
        { image: g2_energia },
        { image: g3_energia },
        { image: g4_energia },
        { image: g5_energia },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Mantri Energia, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Mantri - Blossom",
          image: lalbagh,
          price: "On Request",
          location: "Doddamavalli, Bengaluru",
          projectlocation: "Central Bengaluru",
          state: "Bengaluru",
          developer: "Mantri ",
          bed: "3 - 4 - 5 Apartments",
          size: "On Request",
          url: `/mantri-blossom-doddamavalli-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
